import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import Modal from "../../components/modal";
import RageSelector from "../../components/rangeSlider";
import { DropDownInput } from "../../wrappers/selectInput";
import Button from "../../components/button";
import * as CONSTANTS from "../../utils/CONSTANTS";
import { MultiDropDownInput } from "../../wrappers/multiselectInput";
import { skillNameConverter } from "../../utils/EllowUtils";


export type positionFilterFormFields = {
  companyName: string;
  positionName: string;
  experience: any;
  allocatedTo: any;
  jobRole: any;
  dateWithin: any;
  typeOfJob: any;
  priority: any;
  skills: any;
  skillsCombination: any;
};

interface props {
  onClose?: any;
  ClickHandler?: any;
  allocatedTo?: any;
  defaultSet?: any;
  defaultValues?: any;
  companyList?: [{ companyName: string; companyId: string }];
  positionName?: [{ title: string, jobId: string }]
  skillsList: any;
}

const CRPositionFilter: React.FC<props> = ({
  onClose,
  ClickHandler,
  allocatedTo,
  companyList,
  positionName,
  defaultSet,
  defaultValues,
  skillsList
}) => {
  const formOptions = {    defaultValues: useMemo(() => {
    return defaultValues;
  }, [defaultValues])};

  const [allocationData, setAllocationData] = useState<any>();
  const [range, setRange] = useState<{ from?: number; to?: number }>({from: 0, to: 20,})
  const skillvalues = skillsList && skillsList.length > 0 && skillNameConverter(skillsList) && skillNameConverter(skillsList).length > 0 && skillNameConverter(skillsList).map((item: any) => item.skillName)
 
  useEffect(() => {
    setAllocationData(allocatedTo); 
    if (defaultValues) {
      if (defaultValues.range) {
        setRange(defaultValues.range)
        setValue('experience',defaultValues.range)
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allocatedTo, companyList,defaultValues]);


  const { register, handleSubmit, control, setValue, formState } =
    useForm<positionFilterFormFields>(formOptions);

  const onSubmit = (data: any) => {
    
    ClickHandler(data)
  }

  const rangeChange = (startValue: any, endValue: any) => {
    let range = {
      from: startValue,
      to: endValue,
    };
    setValue("experience", range);
    setRange(range);
  };

  return (
    <Modal title={" "} size="medium" onClose={onClose}>
      <form>
        <div className="form-group">
          <DropDownInput<positionFilterFormFields>
            name="companyName"
            // placeholder="Select Company"
            register={register}
            data={companyList}
            label="Company"
            errors={formState.errors}
            control={control}
            defaultValue={defaultValues && defaultValues.company}
            // allowCustom={false}
          />
        </div>
        <div className="form-group">
          <label className="lablel">Core Skills</label>
          <MultiDropDownInput<positionFilterFormFields>
            name="skills"
            placeholder=""
            data={skillvalues}
            register={register}
            errors={formState.errors}
            control={control}
            allowCustom={false}
          />
          <div className="half-form-wrap">
            <div className="form-group">
              <label className="lablel">Skills combination</label>
              <DropDownInput<positionFilterFormFields>
                name='skillsCombination'
                data={[{ name: 'AND', id: true }, { name: 'OR', id: false }]}
                register={register}
                errors={formState.errors}
                control={control}
                dataItemKey='id'
                textField="name"
              />
            </div>
            <div className="form-group">
              <label className="lablel">
                Experience Range &nbsp;
              <strong>
                {range.from} - {range.to}
              </strong>
              </label>
              <RageSelector
                defaultValue={defaultValues && defaultValues.range}
                onChange={(e: any) =>
                  rangeChange(Math.floor(e.value.start), Math.floor(e.value.end))
                } 
              />
            </div>
          </div>
        </div>
        <div className="half-form-wrap">
          <div className="form-group">
            <DropDownInput<positionFilterFormFields>
              name="allocatedTo"
              data={allocationData}
              register={register}
              errors={formState.errors}
              control={control}
              label="Allocated To"
              defaultValue={defaultValues && defaultValues.allocatedTo}

            />
          </div>
          <div className="form-group">
            <DropDownInput<positionFilterFormFields>
              name="jobRole"
              data={CONSTANTS.jobRoles}
              register={register}
              errors={formState.errors}
              control={control}
              label="Job Role"
              defaultValue={defaultValues && defaultValues.jobRole}
            />
          </div>
        </div>
        <div className="half-form-wrap">
          <div className="form-group">
            <DropDownInput<positionFilterFormFields>
              name="typeOfJob"
              data={CONSTANTS.typeOfJob}
              register={register}
              errors={formState.errors}
              control={control}
              label="Type of Job"
              defaultValue={defaultValues && defaultValues.typeOfJob}
            />
          </div>
          <div className="form-group">
            <DropDownInput<positionFilterFormFields>
              name="priority"
              data={['Hot', 'Warm', 'Cold']}
              label="Priority"
              register={register}
              errors={formState.errors}
              control={control}
              defaultValue={defaultValues && defaultValues.priority}
            />
          </div>
        </div>
        <div className="popupAction">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit(onSubmit)}>
            Apply Filter
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default CRPositionFilter;
